var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"row":"","wrap":"","justify-center":"","align-center":"","pb-2":""}},[_c('vs-row',{attrs:{"xs12":"","sm12":"","md10":""}},[_c('div',{staticClass:"sunset-expired-box"},[(_vm.sunsetContactEmail)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.$i18n.t('login.error.sunset_with_org_email', {
          sunsetOrganizationName: _vm.sunsetOrganizationName,
          sunsetEffectiveDate: _vm.sunsetEffectiveDate,
          sunsetContactEmail: _vm.sunsetContactEmail
        }))}}):_c('p',{domProps:{"innerHTML":_vm._s(_vm.$i18n.t('login.error.sunset_without_org_email', {
          sunsetOrganizationName: _vm.sunsetOrganizationName,
          sunsetEffectiveDate: _vm.sunsetEffectiveDate
        }))}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }